import { useGetList, useTranslate } from "ra-core";
import { SelectInput } from "@/components/admin/select-input";

import type { PurchaseSignalType } from "../types";

import { NOTE_SIGNAL_FIELD } from "./noteSignal";

// [hiperautomacao] While writing a note about a contact, the seller can say
// in the same place whether it was a purchase signal ("asked for a quote
// with measurements"). Found in the CRM walkthrough: people wrote the
// signal as a note and the temperature never moved.
export const NoteSignalInput = () => {
  const translate = useTranslate();
  const { data: types, isPending } = useGetList<PurchaseSignalType>(
    "purchase_signal_types",
    {
      pagination: { page: 1, perPage: 100 },
      sort: { field: "position", order: "ASC" },
    },
  );
  if (isPending || !types?.length) return null;

  return (
    <SelectInput
      source={NOTE_SIGNAL_FIELD}
      label={translate("hiper.temperature.signal.note_question")}
      choices={types.map((signalType) => ({
        id: String(signalType.id),
        name: `${signalType.label} (${translate(
          `hiper.temperature.signal.strength.${signalType.strength}`,
        )})`,
      }))}
      translateChoice={false}
      emptyText={translate("hiper.temperature.signal.note_none")}
      helperText={translate("hiper.temperature.signal.note_helper")}
    />
  );
};
